module.exports = __webpack_public_path__ + "img/leadConfirmed.c37f1eca.svg";